module.exports = __webpack_public_path__ + "static/img/pro13.d3d92b35.png";